import { useForm } from "react-hook-form";
import { useQuery } from "react-query";
import { Link, useNavigate } from "react-router-dom";
//primereact
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { BreadCrumb } from "primereact/breadcrumb";
//components
import Panel from "../../../components/panel/panel";
import Switch from "../../../components/input/Switch.js";
//services
import { getEnterprise } from "../../../services/GlobalRoles/getEnterprise.js";
import { toast } from "react-toastify";
import { patchOrderBlockLand } from "../../../services/Settings/OrderBlockLand/patchOrderBlockLand.js";
import { useAppContext } from "../../../context/AppContext.jsx";
import { Skeleton } from "primereact/skeleton";
import usePermission from "../../../hooks/usePermission.jsx";

export const OrderBlockLand = () => {
  usePermission("154"); // Editar Ordenar Quadra / Lote
  const { nomenclatures, permissions } = useAppContext();
  const nomenclature = JSON.parse(nomenclatures);
  const navigate = useNavigate();
  const form = useForm();
  const errors = form.formState.errors;

  const { data: enterprises } = useQuery({
    queryKey: ["enterprise"],
    queryFn: () => getEnterprise(navigate),
    enabled: !!permissions?.includes("13")
  });
  //  console.log(enterprises);

  const columns = [{ field: "title", header: "Empreendimento" }];

  const items = [
    {
      template: () => (
        <Link to={"/settings/orderBlockLand"} className="p-breadcrumb-link">
          Ordenar {nomenclature[0].label} e {nomenclature[1].label}
        </Link>
      ),
    },
  ];
  const home = {
    template: () => (
      <Link to={"#"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  const getFormErrorMessage = (name) => {
    return errors[name] ? (
      <small className="p-error">{errors[name].message}</small>
    ) : (
      <small className="p-error">&nbsp;</small>
    );
  };

  const handleSwitchChange = async (e, rowData, selection) => {
    // if (e) {
    // console.log(e);
    // console.log(rowData);
    // console.log(selection);
    let data = {};
    data.id = rowData.id;
    if (selection === 1) {
      if (e) {
        data.order_block = 1;
      } else {
        data.order_block = 0;
      }
    }
    if (selection === 2) {
      if (e) {
        data.order_land = 1;
      } else {
        data.order_land = 0;
      }
    }
    const notification = toast.loading("Por favor aguarde...");
    try {
      await patchOrderBlockLand(data);
      toast.update(notification, {
        render: "Ordenação atualizado com sucesso.",
        autoClose: 1000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
    } catch (err) {
      toast.update(notification, {
        render: "Falha ao executar a ação!",
        autoClose: 5000,
        type: "error",
        theme: "colored",
        isLoading: false,
      });
      // }
    }
  };
  return (
    <div className="row d-flex justify-content-between mb-3">
      <div>
        <BreadCrumb
          model={items}
          home={home}
          style={{
            background: "transparent",
            border: "none",
            fontSize: "16px",
          }}
        />
      </div>
      <Panel title={`Empreendimentos Cadastrados`}>
        {!enterprises ? (
          <Skeleton variant="rect" width="100%" height={300} />
        ) : (
          <>
            <DataTable
              rows={5}
              paginator
              stripedRows
              showGridlines
              sortMode="multiple"
              // loading={isLoading}
              selectionMode="single"
              rowsPerPageOptions={[5, 25, 100]}
              value={enterprises}
              emptyMessage="Nenhuma Informação foi encontrada."
              tableStyle={{ minWidth: "0.8rem", fontSize: "0.7rem" }}
            >
              {columns.map((col) => (
                <Column
                  sortable
                  key={col.field}
                  field={col.field}
                  body={col.body}
                  header={col.header}
                />
              ))}
              <Column
                header={nomenclature[0].label}
                body={(rowData) => (
                  <div className="text-center">
                    <Switch
                      name={`block${rowData.id}`}
                      control={form.control}
                      checked={rowData.order_block === 1}
                      getFormErrorMessage={getFormErrorMessage}
                      onChange={(e) => handleSwitchChange(e, rowData, 1)}
                    />
                  </div>
                )}
              />
              <Column
                header={nomenclature[1].label}
                body={(rowData) => (
                  <div className="text-center">
                    <Switch
                      name={`land${rowData.id}`}
                      control={form.control}
                      checked={rowData.order_land === 1}
                      getFormErrorMessage={getFormErrorMessage}
                      onChange={(e) => handleSwitchChange(e, rowData, 2)}
                    />
                  </div>
                )}
              />
            </DataTable>
          </>
        )}
      </Panel>
    </div>
  );
};
